import React from 'react'
import { number, string, func, object, bool, shape } from 'prop-types'
import classNames from 'classnames/bind'


function Cell (props) {
  const { s, c, isFromCell, color, clickCell, style } = props
  const cx = classNames.bind(style)
  return (
    <div
      className={cx({
        cell: true,
        using: isFromCell,
      })}
      style={{ backgroundColor: color }}
      onClick={() => clickCell(s, c)}
    >
      <div className={style.tooltip}>S: {s / 100}, C: {c / 100}</div>
    </div>
  )
}
Cell.propTypes = {
  s: number.isRequired,
  c: number.isRequired,
  fromCell: shape({
    s: number,
    c: number,
  }),
  color: string,
  clickCell: func.isRequired,
  isFromCell: bool.isRequired,
  style: object.isRequired,
}
Cell.defaultProps = {
  color: '#FFF',
}

export default Cell



// WEBPACK FOOTER //
// ./src/components/RangeEditor/Grid/Row/Cell/Cell.jsx